import { Col, Row } from '@rematter/ui-web';
import { cn } from '@rematter/ui-web';

import { useCoreAuditTab } from '../../_state/coreEvents.state';
import { useTranslations } from '../../i18n/useTranslations';

import { CoreEventDetail } from './CoreEventDetail';
import { CoreEventsList } from './CoreEventsList';
import { CoreEventsSidebar } from './CoreEventsSidebar';

export const CoreEventsView = () => {
  const t = useTranslations();
  const [tab, setTab] = useCoreAuditTab();

  return (
    <Col className="@CoreEventsView size-full">
      <Row className="border-b border-neutral/10 px-4">
        <button
          onClick={() => setTab('events')}
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'events'
              ? 'border-b-2 border-primary text-primary'
              : 'text-neutral/60 hover:text-neutral',
          )}
        >
          {t.coreEventsView.tabs.events}
        </button>
        <button
          onClick={() => setTab('inbox')}
          disabled
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'inbox'
              ? 'border-b-2 border-primary text-primary'
              : 'cursor-not-allowed text-neutral/30',
          )}
        >
          {t.coreEventsView.tabs.inbox}
        </button>
      </Row>
      <Row className="flex-1 items-stretch overflow-hidden">
        <CoreEventsSidebar />
        <CoreEventsList />
        <CoreEventDetail />
      </Row>
    </Col>
  );
};
